import { notifications } from 'lib/axios';
import { useQuery } from 'react-query';

export const getNotificationCount = () => {
  return notifications.get(`/admin/count`);
};

export const useNotificationCount = ({ config } = {}) => {
  return useQuery({
    queryKey: ['notification_count'],
    queryFn: () => getNotificationCount(),
    refetchInterval: 5 * 60 * 1000, // 2 minutes
    ...config,
  });
};
